// extracted by mini-css-extract-plugin
module.exports = {"containerImagem":"Foto_containerImagem__CKfZv","carregandoImagem":"Foto_carregandoImagem__peYz7","barra":"Foto_barra__39BLa"};